var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 3a65.527 65.527 0 0 1 9.536.695C28.124 4.075 30 6.339 30 8.988v8.024c0 2.649-1.876 4.913-4.464 5.293a65.25 65.25 0 0 1-4.638.514.518.518 0 0 0-.393.225l-3.673 5.51a1 1 0 0 1-1.664 0l-3.672-5.508a.524.524 0 0 0-.397-.227 65.183 65.183 0 0 1-4.635-.514C3.877 21.925 2 19.66 2 17.013V8.988C2 6.34 3.877 4.075 6.464 3.695A65.535 65.535 0 0 1 16 3zm0 2c-3.115 0-6.203.226-9.245.673C5.167 5.907 4 7.315 4 8.988v8.025c0 1.672 1.167 3.08 2.755 3.314a63.18 63.18 0 0 0 4.492.497 2.524 2.524 0 0 1 1.912 1.11L16 26.197l2.843-4.265c.39-.58 1-.968 1.68-1.08l.23-.027a63.23 63.23 0 0 0 4.492-.497C26.834 20.093 28 18.686 28 17.012V8.988c0-1.674-1.166-3.081-2.755-3.315A63.527 63.527 0 0 0 16 5zm0 9a1 1 0 0 1 0 2h-6a1 1 0 0 1 0-2h6zm6-4a1 1 0 0 1 0 2H10a1 1 0 0 1 0-2h12z",
    fill: "#192340",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.b37b66c59dfa95be7039e590848afebc.svg";
export { ForwardRef as ReactComponent };